module.exports = __webpack_public_path__ + "img/blingbling.0743aca4.png";